/* components/Menu/parts/MenuInfoBlock.jsx */
//import { Compass } from "lucide-react";

import "./MenuInfoBlock.css";

const MenuInfoBlock = ({ visible, total, isOpen }) => {

    //const str = visible <= 1 ? " domonyme" : " domonymes";

    return (
        <div className={`menu-info-block ${isOpen ? "open" : ""}`}>
            <div className={`menu-info ${isOpen ? "open" : ""}`}>
                <div className="visible-count">{visible}</div>
                <div className="separator"></div>
                <div className="total-count">{total}{isOpen ? " domonymes" : ""}</div>
            </div>

        </div>
    )
};

export default MenuInfoBlock;
